import { analytics } from '../firstSnap/config/firebase-config';
import { logEvent as fbLogEvent } from 'firebase/analytics';

export const logEvent = (eventName, params = {}) => {
  try {
    if (analytics && typeof fbLogEvent === 'function') {
      fbLogEvent(analytics, eventName, params);
    }
  } catch {
    // no-op
  }
};

export const trackAffiliateClick = (partnerName, url, meta = {}) => {
  try {
    logEvent('affiliate_click', { partnerName, url, ...meta });
  } catch {}
};

export default { logEvent, trackAffiliateClick };


